export default "__VITE_ASSET__Bx51i7JY__"